export default __webpack_public_path__ + "static/media/your-video.fe185496.PNG";